export default {
    faq: {
        faq: "faq",
        pageTitle: "Frequently Asked Questions",
        items: [
            {
                question: "With an equity release (reverse mortgage), will the bank own my home?",
                answer: "No, you will not transfer ownership of your property to the bank when receiving a reverse mortgage."
            },
            {
                question: "Could I owe more than the value of my home?",
                answer: "As long as you have met your mortgage obligations, the amount you owe on the due date will not be more than the fair market value."
            },
            {
                question: "How can I reduce the interest owing an equity release (reverse mortgage)?",
                answer: "To reduce interest accumulation, you can limit the amount of your initial advance and take out additional funds only as needed. There’s also the option of paying down interest monthly, without a prepayment charge."
            },
            {
                question: "How much equity will I have left?",
                answer: "At any time, the remaining equity on your home will depend on the difference between the home’s current value and the amount owing on the equity release (reverse mortgage). Learn more."
            },
            {
                question: "Are reverse mortgage rates higher than standard mortgages?",
                answer: "Because no payments are required until the mortgage is due, reverse mortgage rates tend to be higher than standard mortgages. We offer a range of fixed and adjustable interest rates so you can choose the interest rate that works best for you."
            },
            {
                question: "How can I use the funds from an equity release (reverse mortgage)?",
                answer: "You could use the funds to cover daily expenses, home renovations, medical bills, in-home care, family needs, trips, or help a relative with a down payment, it’s up to you.&nbsp;We also offer a range of home-financing solutions. You can work with a mortgage broker to find a plan that works for you."
            },
            {
                question: "Can Equitable Bank sell or foreclose on my home?",
                answer: "If you continue to meet your mortgage obligations, you should have no concerns about losing your home to the bank."
            },
            {
                question: "What if I already have a mortgage on my property?",
                answer: "If you have a mortgage, it must be paid off so that the equity release (reverse mortgage) can be registered in first priority. You can use the proceeds from the initial advance to pay off your existing mortgage, any outstanding debt, or lien registered against the property."
            },
            {
                question: "Would I need to sell my house if my spouse passes away?",
                answer: "If both spouses are registered as joint tenants, the surviving spouse can continue to be a borrower and is entitled to all the benefits an equity release (reverse mortgage) has to offer."
            },
            {
                question: "What options do I have for receiving my funds?",
                answer: "You can take the mortgage proceeds upfront as a one-time advance (an Initial Advance). Or you can take a large sum upfront (minimum amount of $25,000) and the remaining funds as Single Advances and/or Recurring Advances scheduled over several years."
            },
            {
                question: "Who is responsible for paying property taxes?",
                answer: "You must pay property taxes directly to the municipality."
            },
            {
                question: "When is a holdback done?",
                answer: "At the time of application or during the life of the equity release (reverse mortgage), we may require a holdback to cover home repairs if deficiencies could affect livability or have the potential to materially affect the home’s future value. We may also require a holdback if there are tax or condominium arrears."
            },
            {
                question: "Is a credit bureau report required?",
                answer: "For each applicant, a credit bureau report is required."
            },
            {
                question: "Can a Power of Attorney (POA) apply on my behalf?",
                answer: "A POA for property may be used when applying for an equity release (reverse mortgage). Your attorney must have the ability to deal with real property. The POA will not be permitted to apply on your behalf simply because you are out of the country."
            },
            {
                question: "Is there a setup fee?",
                answer: "There is a setup fee of $995.00, which will be deducted from the initial advance."
            }
        ]
    }
}



// WEBPACK FOOTER //
// ./src/i18n/translations/en/faq.js